define(function (require, exports, module) {
    var ContentPhoto = require('./ContentPhoto');

    function ContentVideo (video) {
        video = video.item || video;
        this.id = video.id || video.slug;
        this.slug = video.slug;
        this.linkId = isNaN(video.id) ? video.slug : 'c-' + video.id;
        this.blurb = video.blurb || '';
        this.description = video.description || '';
        this.headline = video.headline || '';
        this.title = this.headline;
        this.parseData(video);
    }

    ContentVideo.prototype = {
        parseData: function (video) {
            this.photo = new ContentPhoto(video.image);
            // To simplify LiesContentModel's mediaType compatibility
            this.mediaType = video.mediaType || this.parseKeywords(video.keywordsAll);
            this.review = (this.mediaType === 'M' || this.mediaType === 'N');
            this.statscast = (this.mediaType === 'S');
            this.condensed = this.mediaType === 'C';
            this.recap = this.mediaType === 'R';
            this.parsePlaybackScenarios(video);
        },
        parsePlaybackScenarios: function (video) {
            var playback = this.playback = {};
            var list = playback.list = [];
            var name = playback.name = {};
            var scenarios = video.playbacks;
            var scenario;
            var i = 0;
            var len = scenarios && scenarios.length;

            for (; i < len; i++) {
                scenario = scenarios[i];
                if (scenario && scenario.name && scenario.url) {
                    name[scenario.name] = scenario;
                    list.push(scenario);
                }
            }
        },
        parseKeywords: function (keywords) {
            var len = keywords.length;
            var mediaType = 'T';

            for (var i = 0; i < len; i++) {
                var keyword = keywords[i];

                if (keyword.type === 'mlbtax') {
                    switch (keyword.value) {
                    case 'umpire_review':
                        mediaType = 'N';
                        return mediaType;
                    case 'challenge':
                        mediaType = 'M';
                        return mediaType;
                    case 'vtp_player_tracking':
                        mediaType = 'S';
                        return mediaType;
                    }
                }

                if (keyword.type === 'subject') {
                    switch (keyword.value) {
                    case 'MLBCOM_TOP_PLAY':
                        mediaType = 'T';
                        return mediaType;
                    case 'MLBCOM_CONDENSED_GAME':
                        mediaType = 'C';
                        return mediaType;
                    case 'MLBCOM_COM_RECAP':
                    case 'MLBCOM_GAME_RECAP':
                        mediaType = 'R';
                        return mediaType;
                        break;
                    }
                }
            }
            return mediaType;
        }
    };

    return ContentVideo;
});
